import template from './approve_time_logged_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class ApproveTimeLoggedViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ApproveTimeLoggedHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ApproveTimeLoggedViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	};
};

export default {
	name: 'ApproveTimeHelp',
	dialog_class: ApproveTimeLoggedHelpPage,
	template: template,
	template_filename: 'translation/dialogs/approve_time_logged',
	provider: 'ps'
};
